import Subtitle from '../text/Subtitle';
import FinalPoints from '../text/FinalPoints';
import { useLanguage } from '../../context/LanguageContext';

function Scoreboard({ rounds = [], totalScore = 0 }) {
  const { t } = useLanguage();

  return (
    <section className="mb-4">
      <div className="flex items-center justify-around flex-col sm:flex-row w-[18em] sm:w-[40em] border-b-2 border-gray">
        <div className="flex items-center justify-around w-full sm:basis-3/5">
          {rounds.slice(0, 3).map((points, idx) => (
            <div className="flex flex-col items-center mb-6" key={idx}>
              <Subtitle size="small" text={`${t('round')} ${idx + 1}`} />
              <FinalPoints text={points} />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col items-center mt-6">
        <Subtitle text={t('finalScore')} />
        <FinalPoints size="big" text={totalScore} />
      </div>
    </section>
  );
}

export default Scoreboard;
